/* DashboardConfiguration Store */

import {
  createDashboardConfiguration,
  deleteDashboardConfiguration,
  fetchUserDashboardConfiguration,
  updateDashboardConfiguration
} from '@/api'

const state = {
  layout: []
}

const actions = {
  createDashboardConfiguration (context, payload) {
    return createDashboardConfiguration(payload)
  },
  deleteDashboardConfiguration (context, configurationId) {
    return deleteDashboardConfiguration(configurationId)
  },
  fetchUserDashboardConfiguration (context, loginId) {
    return fetchUserDashboardConfiguration(loginId).then(response => {
      context.commit('setLayout', response.data)
    })
  },
  updateDashboardConfiguration (context, payload) {
    const configurationId = payload['configurationId']
    const configuration = payload['configuration']
    updateDashboardConfiguration(configurationId, configuration)
  }
}

const mutations = {
  setLayout (state, payload) {
    for (let item of payload) {
      item.i = item.configurationId
    }
    state.layout = payload
  }
}

const getters = {
  getLayout (state) {
    return state.layout
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
